import { DataImportFileFilters } from '@/api/requests/import/data-import-file-filters';
import { DataImportFile } from '@/shared/data-import-file';

export class State {
    public dataImportFiles: Array<DataImportFile> = [];
    public totalDataImportFiles: number = 0;
    public filters: DataImportFileFilters = {
        page: 1,
        pageSize: 25,
        type: null,
        partnerPracticeId: null,
        status: null,
    };
}
